import { CREATOR_CLIENTS_PATH } from '../../constants/path'
import getCurrentReduxSelector from '../../../../redux/selectors/get-current'

const getCurrentCreatorClientSelect = getCurrentReduxSelector(
  CREATOR_CLIENTS_PATH.DATA,
  CREATOR_CLIENTS_PATH.CURRENT
)

export default getCurrentCreatorClientSelect
